import $ from 'jquery';

const currentMember = new Promise((resolve) => {
  if (window.tower.me) {
    resolve(window.tower.me);
  } else {
    $(document).ready(() => resolve(window.tower.me));
  }
});

export default currentMember;
